import React from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Compras from './InformesMediosMagneticos';
import Ventas from './InformesMediosMagneticosVentas';

const App = () => {
  return (
    <Tabs defaultActiveKey="compras" id="medios-magneticos-tabs" className="mb-3">
      <Tab eventKey="compras" title="Compras">
        <Compras />
      </Tab>
      <Tab eventKey="ventas" title="Ventas">
        <Ventas />
      </Tab>
    </Tabs>
  );
};

export default App;
